module.exports = {
  theme: {
    colors: {
      primary: '#1d1d22',
      secondary: '#151517',
      first: '#000000',
      twentieth: '#041f3b',
    },
  },
};
